import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import GalleryLayer from "../components/MobileAdLayer";

const GalleryPage = () => {
  return (
    <MasterLayout>
      <GalleryLayer />
    </MasterLayout>
  );
};

export default GalleryPage;
